import axios from '../../../config-axios'
import { ElMessage } from 'element-plus'

export default {
    namespaced: true,
    state: () => ({
        userOptions: {
            loginStatus: false,
            username: null,
            role: 'guest'
        },
        windowLogin: {
            loaderButton: false
        },
    }),
    getters: {
        getUserOptions(state) {
            return state.userOptions
        },
        getLoaderLoginButton(state) {
            return state.windowLogin.loaderButton
        },
    },
    mutations: {
        setLogin(state, options) {
            state.userOptions.loginStatus = options
        },
        setLoaderButtonLogin(state, options) {
            state.windowLogin.loaderButton = options
        },
        setUserParam(state, options) {
            state.userOptions.loginStatus = true
            state.userOptions.username = options.username
            state.userOptions.role = options.role
            state.userOptions.company= options.company
        },
    },
    actions: {
        async postLogin(context, data){
            context.commit('setLoaderButtonLogin', true)
            axios.defaults.headers.common = {}
            await axios.post('user/login/', data).then( response => {
            context.commit('setLogin', true)
            localStorage.setItem('token', response.data.token)
            axios.defaults.headers.common = {'Authorization': `Token ${response.data.token}`}
            context.commit('setLoaderButtonLogin', false)
            context.commit('setUserParam', response.data)
            }).catch( error => {
            console.log(error)
            ElMessage.error('Неверные параметры для входа')
            context.commit('setLoaderButtonLogin', false)
            })
        },
        async postLogout(context) {
            axios.defaults.headers.common = {}
            localStorage.setItem('token', '')
            context.commit('setLogin', false)
        },
        async checkUserInfo(context) {
            await axios.get('user/info/').then( (response) => {
            context.commit('setUserParam', response.data)
            }).catch( error => {
            console.log(error)
            })
        },
    }
}